import React from 'react';
import { AutocompleteRenderGroupParams } from '@mui/material/Autocomplete/Autocomplete';
import ListSubheader from '@mui/material/ListSubheader';
import { SelectComponents } from '../../types';

export const Group: NonNullable<SelectComponents['Group']> = (params: AutocompleteRenderGroupParams) => [
  !!params.group ? (
    <ListSubheader key={params.key} component="div">
      {params.group}
    </ListSubheader>
  ) : null,
  params.children
];
